export function hasBasicEmailFormat(value) {
  if (!value || typeof value !== "string") {
    return false;
  }

  const trimmed = value.trim();
  const at = trimmed.indexOf("@");
  if (at <= 0) {
    return false;
  }

  const local = trimmed.slice(0, at);
  const domain = trimmed.slice(at + 1);
  if (!local || local.includes(" ") || !domain || domain.includes(" ")) {
    return false;
  }

  const dot = domain.lastIndexOf(".");
  return dot > 0 && dot < domain.length - 1;
}

export function getRegistrationEmailValidationError(
  email,
  { requiredMessage = "Email is required" } = {}
) {
  if (!email?.trim()) {
    return requiredMessage;
  }
  if (!hasBasicEmailFormat(email)) {
    return "Please enter a valid email address";
  }
  return "";
}

export function createRegistrationEmailValidator(getEmail, applyError, options) {
  return () => {
    const error = getRegistrationEmailValidationError(getEmail(), options);
    applyError(error);
    return !error;
  };
}

export function getRegistrationUsernameLooksLikeEmailError(username) {
  if (!username?.trim()) {
    return "";
  }
  if (hasBasicEmailFormat(username.trim())) {
    return "Username cannot be an email address";
  }
  return "";
}

export function createRegistrationUsernameValidator(getUsername, applyError) {
  return () => {
    if (!getUsername()?.trim()) {
      applyError("Username is required");
      return false;
    }
    const emailLikeError = getRegistrationUsernameLooksLikeEmailError(getUsername());
    if (emailLikeError) {
      applyError(emailLikeError);
      return false;
    }
    applyError("");
    return true;
  };
}

export function createRegistrationFieldValidators({
  getEmail,
  getUsername,
  setEmailError,
  setUsernameError,
  emailOptions,
}) {
  const validators = {
    validateEmail: createRegistrationEmailValidator(getEmail, setEmailError, emailOptions),
  };

  if (getUsername && setUsernameError) {
    validators.validateUsername = createRegistrationUsernameValidator(
      getUsername,
      setUsernameError
    );
  }

  return validators;
}

export function createStandardRegistrationValidators({
  formData,
  emailField = "email",
  usernameField = "username",
  setEmailError,
  setUsernameError,
  emailOptions,
}) {
  return createRegistrationFieldValidators({
    getEmail: () => formData[emailField],
    getUsername: () => formData[usernameField],
    setEmailError,
    setUsernameError,
    emailOptions,
  });
}
